import type { Template, TemplateFileType } from '@/api/v4/template.api';
import { downloadLinkAutomatically } from '@/helpers/download-link-automatically';
import { Icon } from '@/ui/icons/icon';
import { styled } from 'goober';
import { colorIcon } from '@/ui/icons/functions';
import { useTranslation } from 'react-i18next';

interface Props {
  fileType: TemplateFileType;
  template?: Template;
}

export const TemplateLink = ({ template, fileType }: Props) => {
  const { t } = useTranslation('settings', {
    keyPrefix: 'manageTemplatesTab',
  });
  const downloadTemplate = async () => {
    if (!template || !template.link) {
      return;
    }

    await downloadLinkAutomatically(template.link, template.name);
  };

  return (
    <FileNameLink
      onClick={downloadTemplate}
      disabled={!template || !template.link}
    >
      <Icon icon="FilePdf" />
      <span>{t([`fileTypes.${fileType}`])}</span>
    </FileNameLink>
  );
};

const FileNameLink = styled('div')<{ disabled: boolean }>`
  ${({ theme }) => theme.typography.actionsPanel.files.fileName}
  display: flex;
  align-items: center;
  gap: 4px;

  cursor: pointer;

  ${({ disabled, theme }) =>
    disabled &&
    `
        color: ${theme.colors.gray.c8};
        pointer-events: none;
        cursor: default;
        &:hover {
          text-decoration: none;
        }

        ${colorIcon(theme.colors.gray.c8)};
      `};
`;
